import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import CustomerManagementPage from '@/areas/customers/Customers/CustomerManagementPage';
import { canViewCustomers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/customers/')({
    staticData: { access: { permissions: canViewCustomers }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CustomerManagementPage />;
}
